/**
 * Compte retenu par cet appareil pour la connexion (24/10/2026, issue #138),
 * comme les grands services : la fois suivante, l'écran propose directement
 * « Continuer avec Face ID » à la personne qui s'est connectée par sa clé d'accès,
 * ou préremplit son identifiant.
 *
 * Gardé sur l'appareil seulement : identifiant, prénom et nom, et le fait qu'une
 * clé d'accès a servi ici. Jamais de mot de passe ni de jeton. Rien n'est demandé
 * au serveur sur l'identifiant (aucune liste des comptes ne se déduit). « Autre
 * compte » l'efface.
 */
const KEY = 'fa.compte';
const MAX = 254;

export interface RememberedAccount {
  identifier: string;
  name: string;
  /** Une clé d'accès (Face ID, empreinte, Windows Hello…) a servi sur cet appareil. */
  passkey: boolean;
}

export function rememberedAccount(): RememberedAccount | undefined {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) ?? 'null') as Partial<RememberedAccount> | null;
    if (!value || typeof value.identifier !== 'string' || typeof value.name !== 'string') return undefined;
    return { identifier: value.identifier.slice(0, MAX), name: value.name.slice(0, 120), passkey: value.passkey === true };
  } catch {
    return undefined;
  }
}

/** Fusionne avec ce qui est retenu ; un autre compte remplace l'ancien. */
export function rememberAccount(patch: Partial<RememberedAccount> & { identifier?: string }): void {
  const current = rememberedAccount();
  const other = patch.identifier !== undefined && current && current.identifier !== patch.identifier;
  const next: RememberedAccount = {
    identifier: (patch.identifier ?? current?.identifier ?? '').slice(0, MAX),
    name: (patch.name ?? (other ? '' : current?.name) ?? '').slice(0, 120),
    passkey: patch.passkey ?? (other ? false : current?.passkey) ?? false,
  };
  if (!next.identifier) return;
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* stockage refusé (navigation privée) : l'écran demande l'identifiant */
  }
}

export function forgetRememberedAccount(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* rien à effacer */
  }
}
